import React from "react";

import { Switch } from "react-router-dom";

import DesktopLayout from "@components-shared/desktop/layout/DesktopLayout";
import { NoMatchRoute, RouteElement } from "@components/navigation";
import { ReactLazyImportWithGuard as lazy } from "@lib/lazy-import-with-guard";
//#region lazy

import { getCurrentCulture } from "@utils";

const loadFailPath = `/${getCurrentCulture()}/app-update`;

// prettier-ignore
const AboutUsPage = lazy(loadFailPath, () => import("@features/info/about-us/desktop"));
// prettier-ignore
const BettingRulesPage = lazy(loadFailPath, () => import("@features/info/betting-rules/desktop"));
// prettier-ignore
const BonusTermsPage = lazy(loadFailPath, () => import("@features/info/bonus-terms/desktop"));
// prettier-ignore
const FreebetTermsPage = lazy(loadFailPath, () => import("@features/info/freebet-terms/desktop"));
// prettier-ignore
const ContactPage = lazy(loadFailPath, () => import("@features/info/contact/desktop"));
// prettier-ignore
const ComplaintsPage = lazy(loadFailPath, () => import("@features/info/complaints/desktop"));
// prettier-ignore
const HelpPage = lazy(loadFailPath, () => import("@features/info/help/desktop"));
// prettier-ignore
const OurPartnersPage = lazy(loadFailPath, () => import("@features/info/our-partners/desktop"));
// prettier-ignore
const PrivacyPage = lazy(loadFailPath, () => import("@features/info/privacy/desktop"));
// prettier-ignore
const ResponsibleGamingPage = lazy(loadFailPath, () => import("@features/info/responsible-gaming/desktop"));
// prettier-ignore
const TermsAndConditionsPage = lazy(loadFailPath, () => import("@features/info/terms-and-conditions/desktop"));
// prettier-ignore
const PaymentOptionsPage = lazy(loadFailPath, () => import("@features/payment/payment-options/desktop"));
// prettier-ignore
const NewsPage = lazy(loadFailPath, () => import("@features/cms/news/desktop/page/NewsPage"));
// prettier-ignore
const CouponBonusPage = lazy(loadFailPath, () => import("@features/info/bonus-terms/desktop/CouponBonusPage"));

//#endregion lazy

export default function InfoPagesLayoutTemplate() {
	return (
		<DesktopLayout>
			<section className="l--content l--content--full">
				<div className="l--content__main">
					<div className="container">
						<Switch>
							<RouteElement exact path="/:culture/info/about-us">
								<AboutUsPage />
							</RouteElement>

							<RouteElement exact path="/:culture/info/help">
								<HelpPage />
							</RouteElement>
							<RouteElement exact path="/:culture/info/contact">
								<ContactPage />
							</RouteElement>

							<RouteElement exact path="/:culture/info/complaints">
								<ComplaintsPage />
							</RouteElement>

							<RouteElement
								exact
								path="/:culture/info/betting-rules"
							>
								<BettingRulesPage />
							</RouteElement>

							<RouteElement
								exact
								path="/:culture/info/bonus-terms"
							>
								<BonusTermsPage />
							</RouteElement>

                            <RouteElement
								exact
								path="/:culture/info/freebet-terms"
							>
								<FreebetTermsPage />
							</RouteElement>

							<RouteElement
								exact
								path="/:culture/info/our-partners"
							>
								<OurPartnersPage />
							</RouteElement>

							<RouteElement exact path="/:culture/info/privacy">
								<PrivacyPage />
							</RouteElement>

							<RouteElement
								exact
								path="/:culture/info/payment-options"
							>
								<PaymentOptionsPage />
							</RouteElement>

							<RouteElement
								exact
								path="/:culture/info/responsible-gaming"
							>
								<ResponsibleGamingPage />
							</RouteElement>

							<RouteElement
								exact
								path="/:culture/info/terms-and-conditions"
							>
								<TermsAndConditionsPage />
							</RouteElement>

							<RouteElement
								exact
								path="/:culture/info/news-announcements/:abrv"
							>
								<NewsPage />
							</RouteElement>

							<RouteElement
								exact
								path="/:culture/info/coupon-terms"
							>
								<CouponBonusPage />
							</RouteElement>

							<NoMatchRoute />
						</Switch>
					</div>
				</div>
			</section>
		</DesktopLayout>
	);
}

`# Bonus - Terms and conditions\n\n**100% Welcome Bonus up to 100 EUR - Claim your Bonus Now**\n\n**Customer with either new or existing account can claim the bonus on the first/next deposit.**\n\n## Terms and Conditions:\n\n1. This promotion is exclusive for all customers. The bonus is only valid for sports and live betting.\n2. Once you register and verify your account, the welcome bonus on your first/next deposit will be automatically added to your account. Please note that your account must be verified before claiming the bonus. In case that you make your first deposit before your account is verified, the bonus can be claimed anyway on the next deposit after verifying your account.\n3. In case that the bonus is not automatically granted after it's claimed, please contact **payment@tipwin.com**. The responsible department will review the case and respond accordingly.\n4. Rollover – The total amount held as bonus funds must be wagered minimum 7 times (7X) with all bets settled before the deposit amount and the bonus funds are released for withdrawal.  \n***Example***: *Customer makes a deposit of 200 EUR and receives the full bonus amount of 100 EUR. The deposit amount of 200 EUR + bonus funds of 100 EUR = 300 EUR. The whole amount of 300 EUR must be wagered minimum 7 times (7X) before the funds are released for withdrawal.*\n5. Other conditions: The maximum stake per ticket included in calculating the rollover is 100 EUR. The minimum odd per ticket included in calculating the rollover is 1.80.\n6. If you have more than 1 EUR on your account balance and you make a new deposit claiming the bonus with, you will not be able to place a withdrawal request until the bonus rollover conditions are met. **If you make a new deposit while the previously claimed bonus is not released, you will not be able to place a withdrawal request until the bonus rollover conditions are met**.\n7. The bonus is limited to one betting account per person, family, household or computer. By suspicion of abuse via multiple registrations (fictitious accounts, player communities) or balance betting, Tipwin reserves the right to recall the bonus and any resulting winnings.\n8. By redeeming the bonus the player accepts the bonus terms and conditions as well as the general terms and conditions of Tipwin Limited, which can be found at www.tipwin.com. Tipwin reserves the right to amend or recall this offer at any time at its own decision."`;
